export default __webpack_public_path__ + "static/media/Group 1602.98978926.png";